import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export type DisplayDeviceType = 'monitor' | 'tv' | 'beamer' | 'vr';

export interface DisplayDeviceOption {
    label: string;
    value: DisplayDeviceType;
}

/** The fixed set of output devices a member can pick from (in display order). */
export const DISPLAY_DEVICE_OPTIONS: DisplayDeviceOption[] = [
    { label: 'Monitor', value: 'monitor' },
    { label: 'TV', value: 'tv' },
    { label: 'Beamer', value: 'beamer' },
    { label: 'VR', value: 'vr' },
];

@Injectable()
export class DisplayDeviceService {
    private apiPrefUrl = `${environment.apiBaseUrl}/api/playerDisplayDevice.php`;

    constructor(private http: HttpClient) {}

    /** Read the preference of the logged-in member (admin: another driver). */
    getPreference(user_name?: string): Observable<{ display_device: DisplayDeviceType | null }> {
        const params = user_name ? new HttpParams().set('user_name', user_name) : undefined;
        return this.http.get<{ display_device: DisplayDeviceType | null }>(this.apiPrefUrl, { params });
    }

    /** Set/clear the preference of the logged-in member (admin: another driver). */
    setPreference(
        display_device: DisplayDeviceType | null,
        user_name?: string,
    ): Observable<{ display_device: DisplayDeviceType | null }> {
        return this.http.post<{ display_device: DisplayDeviceType | null }>(this.apiPrefUrl, {
            display_device,
            ...(user_name ? { user_name } : {}),
        });
    }
}
